import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  margin: 24px 30px;

  @media only screen and (min-width: calc(${themeGet(
      'breakpoints.md',
    )} + 1px)) {
    /* margin: 0; */
    margin: 24px auto;
    width: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 409px;
    margin: 0 auto;
  }
`;

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.white')};

  p {
    font-weight: ${themeGet('fontWeights.bold')};
    letter-spacing: normal;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 1.22;
  }

  padding: 32px 24px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: auto;
    width: 464px;
    p {
      font-size: 24px;
      line-height: 1.33;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 0;
    width: unset;
    p {
      font-size: 28px;
      line-height: 1;
    }
    padding: 48px 40px;
  }
`;

export const Collection = styled.ul`
  &.no-bullets {
    margin-top: 32px;
  }

  li:not(:first-child) {
    margin-top: 0;
  }

  li {
    font-weight: ${themeGet('fontWeights.normal')};
    letter-spacing: normal;
    font-size: 16px;
    line-height: 1.5;
    padding: 8px 0;

    a {
      span {
        border-bottom: 1px solid transparent;
      }

      &:hover {
        span {
          border-bottom: 1px solid ${themeGet('colors.pc-red', '#E1251B')};
        }
      }
    }

    p {
      font-size: 16px;
      margin-bottom: unset;
      font-weight: ${themeGet('fontWeights.bold')};

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        font-size: 18px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    li {
      font-size: 16px;
      line-height: 1.5;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    li {
      font-size: 18px;
      line-height: 1.56;

      a {
        font-size: 18px;
      }
    }
  }
`;
